import { useState } from "react";

import { getLegacyUrl } from "../../api";

export default function ProcessorExportTemplatesView() {
  const [downloading, setDownloading] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  async function handleExport() {
    setDownloading(true);
    setStatus("");
    setError("");

    try {
      const response = await fetch("/api/export-templates/", {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("Failed to download templates.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");

      anchor.href = url;
      anchor.download = "Templates.zip";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.URL.revokeObjectURL(url);

      setStatus("Templates downloaded successfully.");
    } catch (requestError) {
      setError(requestError.message || "Failed to download templates.");
    } finally {
      setDownloading(false);
    }
  }

  function openLegacyExportPage() {
    window.open(getLegacyUrl("/api/export-templates/"), "_blank", "noreferrer");
  }

  return (
    <section className="processor-view">
      <div className="workspace-panel processor-view__hero">
        <div>
          <p className="eyebrow">Processor</p>
          <h2>Export Template</h2>
          <p className="config-view__intro">
            Download the generated template ZIP from the existing Django backend. After export, the
            backend resets the generated template folder back to its base files.
          </p>
        </div>

        <div className="processor-view__hero-actions">
          <div className="processor-summary-card">
            <strong>ZIP</strong>
            <span>template bundle</span>
          </div>
          <button className="ghost-button" type="button" onClick={openLegacyExportPage}>
            Open Legacy Export
          </button>
        </div>
      </div>

      {status ? <div className="config-banner config-banner--success">{status}</div> : null}
      {error ? <div className="config-banner config-banner--error">{error}</div> : null}

      <div className="processor-summary-grid">
        <article className="workspace-panel workspace-panel--compact">
          <p className="eyebrow">Download</p>
          <h2>Templates.zip</h2>
          <p className="config-note">Exports all generated `.xlsx` templates for the logged-in company.</p>
        </article>

      </div>

      <article className="workspace-panel">
        <div className="processor-table__header">
          <div>
            <p className="eyebrow">Export Action</p>
            <h2>Download template bundle</h2>
          </div>
        </div>

        <p className="config-note">
          Use this action when template generation is complete and you are ready to download the
          consolidated ZIP package.
        </p>

        <div className="processor-action-list">
          <button className="primary-button processor-action-button" type="button" onClick={handleExport} disabled={downloading}>
            {downloading ? "Downloading..." : "Export Templates"}
          </button>
          <button className="ghost-button processor-action-button" type="button" onClick={openLegacyExportPage}>
            Open Legacy Endpoint
          </button>
        </div>
      </article>
    </section>
  );
}
